/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Invalid_Format_ToastInputs */

const en_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid file format. Please select a valid file format.`)
};

const fr_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format de fichier invalide. Veuillez selectionner un format valide.`)
};

const de_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiges Dateiformat. Bitte wählen Sie ein gültiges Dateiformat.`)
};

const it_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato file non valido. Seleziona un formato file valido.`)
};

const ru_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неверный формат файла. Пожалуйста, выберите допустимый формат файла.`)
};

const es_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de archivo no válido. Seleccione un formato de archivo válido.`)
};

const zh_cn2_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件格式无效。请选择有效的文件格式。`)
};

const ja_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なファイル形式です。有効なファイル形式を選択してください。`)
};

const hi_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अमान्य फ़ाइल प्रारूप। कृपया एक मान्य फ़ाइल प्रारूप चुनें।`)
};

const pt_pt2_marker_import_invalid_format_toast = /** @type {(inputs: Marker_Import_Invalid_Format_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de arquivo inválido. Selecione um formato de arquivo válido.`)
};

/**
* | output |
* | --- |
* | "Invalid file format. Please select a valid file format." |
*
* @param {Marker_Import_Invalid_Format_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_invalid_format_toast = /** @type {((inputs?: Marker_Import_Invalid_Format_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Invalid_Format_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_invalid_format_toast(inputs)
	if (locale === "de") return de_marker_import_invalid_format_toast(inputs)
	if (locale === "it") return it_marker_import_invalid_format_toast(inputs)
	if (locale === "ru") return ru_marker_import_invalid_format_toast(inputs)
	if (locale === "es") return es_marker_import_invalid_format_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_invalid_format_toast(inputs)
	if (locale === "ja") return ja_marker_import_invalid_format_toast(inputs)
	if (locale === "hi") return hi_marker_import_invalid_format_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_invalid_format_toast(inputs)
	return en_marker_import_invalid_format_toast(inputs)
});